import { render, staticRenderFns } from "./CardTeam.vue?vue&type=template&id=0e324835&"
import script from "./CardTeam.vue?vue&type=script&lang=js&"
export * from "./CardTeam.vue?vue&type=script&lang=js&"
import style0 from "./CardTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports